import type { FairValueHistogramBucket } from '../fairValueHistogramFragment';
import { Group } from '@visx/group';
import { BarRounded } from '@visx/shape';
import type { ScaleBand, ScaleLinear } from 'd3-scale';
import { cn } from '@simplywallst/ui-core/next';
import { Fragment } from 'react';

type Props = {
  xBandScale: ScaleBand<number>;
  yScale: ScaleLinear<number, number, never>;
  buckets: FairValueHistogramBucket[];
  height: number;
  selectedBucket: FairValueHistogramBucket | null;
};

export const FairValueHistogramChartBars = ({
  xBandScale,
  yScale,
  buckets,
  height,
  selectedBucket,
}: Props) => {
  const bandwidth = xBandScale.bandwidth();
  const padding = (xBandScale.padding() * bandwidth) / 2;

  return (
    <Group>
      {buckets.map((bucket, i) => {
        const isSelected = selectedBucket?.min === bucket.min;
        const y = yScale(bucket.primaryCount);
        const x = xBandScale(bucket.min) ?? 0;

        return (
          <Fragment key={`bar-${i}`}>
            <BarRounded
              radius={4}
              top
              x={x}
              y={y + padding}
              width={bandwidth}
              height={Math.max(0, height - y - padding)}
              className="fill-chart-03"
            />
            <rect
              x={x - padding}
              y={0}
              width={bandwidth + padding * 2}
              height={height}
              className={cn(
                'transition-colors',
                isSelected ? 'fill-transparentSubtle' : 'fill-transparent'
              )}
            />
          </Fragment>
        );
      })}
    </Group>
  );
};
